/* eslint-disable new-cap */
import React, { useContext, useEffect, useState } from 'react';
import QRCode from 'qrcode.react';
import { useParams, useHistory } from 'react-router-dom';
import Firebase from '../../../services/firebase';
import Certifield from '../../../assets/certificado.png';
import Invalid from '../../../assets/invalid.png';
import Loader from '../../../assets/loader.gif';
import PosicoesContext from '../../../context/posicoes.context';
import './autentication.scss';
import { notify } from '../../../functions/notifications';
import { Certificado } from '../../../components/modals';

function Authentication() {
  const { setIsScreenCertifield } = useContext(PosicoesContext);
  const history = useHistory();
  const { id, uid } = useParams();
  const [venda, setVenda] = useState([]);
  const [logado, setLogado] = useState(false);
  const [carregando, setCarregando] = useState(true);
  // function printDocument() {
  //   const input = document.querySelector('.autentication-print');
  //   html2canvas(input)
  //     .then((canvas) => {
  //       const imgData = canvas.toDataURL('image/png');
  //       const pdf = new jsPDF();
  //       pdf.addImage(imgData, 'JPEG', 0, 0);
  //       // pdf.output('dataurlnewwindow');
  //       pdf.save('download.pdf');
  //     });
  // }

  useEffect(() => {
    setIsScreenCertifield(true);
  }, []);

  useEffect(() => {
    Firebase.firestore().collection('certificates').doc(uid).get()
      .then((usr) => {
        const userRec = usr.data();
        setLogado(true);
        setCarregando(true);
        if (userRec) {
          const { vendas } = userRec;
          const vendaLocalizada = vendas.filter((item) => Object.keys(item)
            .includes(id) && item);
          setCarregando(false);
          setVenda(vendaLocalizada);
          return setCarregando(false);
        }
        setCarregando(false);
        return setVenda([]);
      })
      .catch((err) => {
        const { message } = err;
        const mensagem = message.split(' ')[0] === 'Missing' ? 'Ops, efetue o login' : message;
        return notify('error', mensagem);
      });
  }, [logado]);

  const openUrl = (url) => {
    window.open(url, '_blank');
  };

  function typeLoading() {
    const loader = (
      <div className="loader-carregando">
        <img src={Loader} alt="Carregando" />
        <span>Carregando Informações, por favor aguarde...</span>
      </div>
    );

    return loader;
  }

  return (
    <div id="autentication-main">
      <div className={`autentication-content-${'true'}`}>
        { carregando
          ? (
            typeLoading()
          )
          : (
            <>
              { venda.length === 0 ? (
                <div className="certifield-invalid">
                  <img src={Invalid} alt="Inválido" />
                  <span>
                    Ops!!! Certificado inválido
                  </span>
                  <button className="buttons-transparent" onClick={() => history.push('/')} type="button">
                    <i className="fas fa-home">
                      <span>Voltar a página principal</span>
                    </i>
                  </button>
                </div>
              )
                : (
                  <>
                    <div className="autentication-aside-left">
                      <div className="autentication-print">
                        <div className="certifield-qr-code">
                          <QRCode
                            value={`https://agsafe.netlify.app/authentication/${id}/key=${uid}`}
                            level="L"
                            size="200"
                            fgColor="#000000"
                            bgColor="#FFFFFF"
                            renderAs="svg"
                            className="qrcode-auth"
                          />
                        </div>
                        <img src={Certifield} alt="Certifield" />
                      </div>
                    </div>
                    <div className="autentication-aside-rigth">
                      <div className="autentication-rigth-title">
                        {venda.length > 0
              && (
                <>
                  <strong>
                    Vendedor:
                  </strong>
                  <span>
                    {`${venda[0].vendedor.vendedor}`}
                  </span>
                </>
              )}
                      </div>
                      <div className="autentication-rigth-body">
                        <div className="info-autenticate">
                          {
                venda.map((data) => {
                  const [p1, p2] = Object.keys(data);
                  const key = p1 !== 'vendedor' ? p1 : p2;
                  const { modalidade } = data[key];
                  const modalidades = modalidade.map((mod) => {
                    const keyMod = Object.keys(mod)[0];
                    return (
                      mod[keyMod].nome
                    );
                  }).join(', ');
                  return (
                    <>
                      <div>
                        <strong>
                          Data da Compra:
                        </strong>
                        <span>
                          {`${data[key].dataCompra}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Cliente:
                        </strong>
                        <span>
                          {`${data[key].empreendimento}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Telefone:
                        </strong>
                        <span>
                          {`${data[key].telefone}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Atividade:
                        </strong>
                        <span>
                          {`${data[key].atividade}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Localidade:
                        </strong>
                        <span>
                          {`${data[key].municipio}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Registro SEAPDR:
                        </strong>
                        <span>
                          {`${data[key].registro}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Validade do registro:
                        </strong>
                        <span>
                          {`${data[key].validade}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          CPF/CNPJ:
                        </strong>
                        <span>
                          {`${data[key].cpfcnpj}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Tipo de tratamento:
                        </strong>
                        <span>
                          {`${data[key].culturaTratada}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Tipo do produto:
                        </strong>
                        <span>
                          {`${data[key].produtoAplicado}`}
                        </span>
                      </div>
                      <div>
                        <strong>
                          Modalidade de Aplicação:
                        </strong>
                        <span>
                          {`${modalidades}`}
                        </span>
                      </div>
                    </>
                  );
                })
              }
                        </div>
                      </div>
                      <Certificado props={{ clienteUid: venda[0][id].uid, userUid: uid }} />
                      <div className="autentication-download-files">
                        <span>
                          Baixar Arquivos
                        </span>
                        <div className="files">
                          <div className="item">
                            <button
                              onClick={() => openUrl(venda[0][id].filesUpload.receituario)}
                              type="button"
                              className="buttons-transparent"
                            >
                              <i className="far fa-file-pdf">
                                <span>
                                  Receituário Ag.
                                </span>
                              </i>
                            </button>
                          </div>
                          <div className="item">
                            <button
                              onClick={() => openUrl(venda[0][id].filesUpload.decaAplicador)}
                              type="button"
                              className="buttons-transparent"
                            >
                              <i className="far fa-file-pdf">
                                <span>
                                  Deca Aplicador
                                </span>
                              </i>
                            </button>
                          </div>
                          <div className="item">
                            <button
                              onClick={() => openUrl(venda[0][id].filesUpload.decaProdutor)}
                              type="button"
                              className="buttons-transparent"
                            >
                              <i className="far fa-file-pdf">
                                <span>
                                  Deca Produtor
                                </span>
                              </i>
                            </button>
                          </div>
                          <div className="item">
                            <button
                              onClick={() => openUrl(venda[0][id].filesUpload.notaFiscal)}
                              type="button"
                              className="buttons-transparent"
                            >
                              <i className="far fa-file-pdf">
                                <span>
                                  Nota Fiscal
                                </span>
                              </i>
                            </button>
                          </div>
                        </div>
                        <div className="buttons-alternative">
                          <button
                            className="buttons-transparent"
                            data-toggle="modal"
                            data-target="#modal-certificado"
                            type="button"
                          >
                            <i className="fas fa-download">
                              <span>
                                Baixar Selo Venda Orientada
                              </span>
                            </i>
                          </button>
                          <button className="buttons-transparent" type="button">
                            <i className="fas fa-globe-africa">
                              <a href="http://sda.rs.gov.br/#/consultasPublicas" target="_blank" alt="Consultas Públicas" rel="noreferrer">
                                <span>
                                  Verificar Pontos Sensíveis
                                </span>
                              </a>
                            </i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
            </>
          )}
      </div>
    </div>
  );
}

export default Authentication;
